import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Dashboard from "./Dashboard";
import { getScouts } from "../../actions/surveyActions";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../services/axiosInstance";
import { APIS } from "../../services/config";

const RequestAudio = ({ location }) => {
  const [file, setFile] = useState("");
  const [audioUrl, setAudioUrl] = useState(""); // will store { id, url }
  const [audioDuration, setAudioDuration] = useState();
  const [error, setError] = useState("");

  let history = useHistory();

  const fetchScout = useSelector((state) => state.fetchScout);
  const { data: scoutData } = fetchScout;
  const dispatch = useDispatch();

  const { request } = location.state || {};

  // Audio Duration Helper Function
  async function getDuration(file) {
    const url = URL.createObjectURL(file);
    return new Promise((resolve) => {
      const audio = document.createElement("audio");
      audio.muted = true;
      const source = document.createElement("source");
      source.src = url; // blob URL
      audio.preload = "metadata";
      audio.appendChild(source);
      audio.onloadedmetadata = function () {
        resolve(audio.duration);
      };
    });
  }

  // Get presigned upload URL from backend
  const getUploadUrl = async (mmCampaignRef, mimeType) => {
    const {
      baseUrl,
      getMultimediaUploadUrl: { path },
    } = APIS;

    const res = await axiosInstance.post(baseUrl + path, {
      mmCampaignRef,
      mimeType,
    });

    return res.data; // { uploadUrl, finalUrl, expiresIn }
  };

  const uploadAudio = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Validate MIME type / extension
    const allowedTypes = ["audio/mpeg", "audio/mp3"];
    const fileName = selectedFile.name.toLowerCase();

    const hasValidExtension =
      fileName.endsWith(".mp3") ||
      fileName.endsWith(".wav") ||
      fileName.endsWith(".ogg");

    if (!allowedTypes.includes(selectedFile.type) && !hasValidExtension) {
      setError("Unsupported audio format. Please upload MP3 files only.");
      setFile("");
      setAudioUrl("");
      return;
    }

    try {
      const durationSec = await getDuration(selectedFile);
      const durationMin = durationSec / 60;

      setAudioDuration(durationMin);

      if (durationMin > 0.5) {
        setError(
          "Audio is too long. Please upload an audio file that is 30 seconds or less."
        );
        setFile("");
        setAudioUrl("");
        return;
      }

      setError("");

      // Preview
      const src = URL.createObjectURL(selectedFile);
      setFile(src);

      const mmCampaignRef = request?.mmCampaignRef || request?.requestRef;
      const mimeType = selectedFile.type || "audio/mpeg";

      const { uploadUrl, finalUrl } = await getUploadUrl(
        mmCampaignRef,
        mimeType
      );

      await fetch(uploadUrl, {
        method: "PUT",
        body: selectedFile,
        headers: {
          "Content-Type": mimeType,
        },
      });

      setAudioUrl({ id: mmCampaignRef, url: finalUrl });
    } catch (err) {
      console.error(err);
      setError(err?.message || "Failed to upload audio");
      setFile("");
      setAudioUrl("");
    }
  };
  const resetFile = async (e) => {
    e.preventDefault();
    setFile("");
    setAudioUrl("");
    setError("");
  };

  useEffect(() => {
    dispatch(getScouts());
  }, [dispatch]);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!audioUrl?.url) {
      setError("No audio uploaded");
      return;
    }

    try {
      const {
        baseUrl,
        submitMultimediaResponse: { path },
      } = APIS;

      const payload = {
        mmCampaignRef: request?.mmCampaignRef || request?.requestRef,
        responseURL: audioUrl.url,
        // responseURLs: [], // only if multi-file
        optional_message: "", // or bind to an input if you want
      };

      const res = await axiosInstance.post(baseUrl + path, payload);

      if (res.status === 200) {
        history.push({
          pathname: "/request-submit-success",
          state: { request },
        });
      } else {
        setError(res.data?.message || "Failed to submit response");
      }
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || "Failed to submit response");
    }
  };

  return (
    <div>
      <Dashboard />
      {file === "" ? (
        <div className="modal">
          <Link
            to="/dashboard"
            className="modal-bg w-inline-block"
            style={{ backdropFilter: "blur(16px)" }}
          ></Link>
          <div className="w-embed"></div>
          <div className="padding-6 background-color-3 radius-large box-shadow-large width-full max-width-xl">
            <div className="modal-section">
              <h5 className="text-color-4 margin-0 weight-normal">
                <strong> {request?.requestName}</strong>
              </h5>
              <div className="padding-top-6 margin-top-6 border-top-2px">
                <div className="upload audio">
                  <div className="in-upload audio">
                    You can preview before sending
                  </div>
                </div>
              </div>
            </div>

            <div className="padding-top-6 border-top-2px">
              <label
                htmlFor="formId"
                className="button background-color-brand w-button"
              >
                Upload Audio
                <input
                  name=""
                  type="file"
                  id="formId"
                  hidden
                  accept=".mp3,audio/*"
                  onChange={uploadAudio}
                />
              </label>
              <p className="text-color-2 margin-top-4 margin-bottom-0 text-small">
                Only <strong>mp3</strong> files supported. File must not be
                longer than 30 seconds.
                <br />
              </p>
              {error && (
                <p
                  className="text-small margin-top-4"
                  style={{ color: "#FFCC00" }}
                >
                  {error}
                </p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="modal">
          <Link
            to="/dashboard"
            className="modal-bg w-inline-block"
            style={{ backdropFilter: "blur(16px)" }}
          ></Link>
          <div className="w-embed"></div>
          <form>
            <div className="padding-6 background-color-3 radius-large box-shadow-large width-full max-width-xl">
              <div className="modal-section">
                <h5 className="text-color-4 margin-0 weight-normal">
                  <strong>{request?.requestName}</strong>
                </h5>
                <div className="padding-top-6 margin-top-6 border-top-2px">
                  <div className="upload recording audio done">
                    <div className="w-embed">
                      <audio controls>
                        <source src={file} />
                        Your browser does not support the audio element.
                      </audio>
                    </div>
                    <button
                      className="button button-small background-color-red w-button"
                      onClick={resetFile}
                      style={{ marginLeft: "30px" }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
              <div className="padding-top-6 border-top-2px flex-space-between margin-top-6 flex-align-center portrait-flex-column portrait-flex-align-start">
                <p className="text-color-2 margin-top-4 margin-bottom-0 text-small">
                  Only <strong>mp3</strong> files supported. File must not be
                  longer than 30 seconds.
                  <br />
                </p>
                {error && (
                  <p
                    className="text-small margin-top-4"
                    style={{ color: "#FFCC00" }}
                  >
                    {error}
                  </p>
                )}
                <button
                  className="button-secondary w-button"
                  disabled={audioDuration > 0.5 || !audioUrl?.url}
                  onClick={onSubmit}
                >
                  {audioUrl?.url ? "Submit" : "Uploading"}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default RequestAudio;
